<template>
    <div>
        <credit-score :score="score"></credit-score>

        <credit-factors v-if="factors.length" :factors="factors" div-class="mt-3"></credit-factors>
        <credit-alert v-if="alerts.length" :alerts="alerts" class="mt-3"></credit-alert>
        <credit-details v-if="details.length" :details="details"></credit-details>
        <credit-debt v-if="Object.keys(creditBalances).length || publicRecords.length" :credit-balances="creditBalances"
            :public-records="publicRecords"></credit-debt>
        <credit-public-records v-if="publicRecords.length" :public-records="publicRecords"></credit-public-records>
        <credit-accounts :hide-actions="mode === 'print'" :collection="collection" :trade="trade"
            v-if="Object.keys(collection).length || Object.keys(trade).length"></credit-accounts>
    </div>
</template>

<script>
export default {
    name: "credit-summary",
    components: {
        CreditScore: () =>
            import("@components/screen/components/Credit/CreditScore"),
        CreditFactors: () =>
            import("@components/screen/components/Credit/CreditFactors"),
        CreditAlert: () =>
            import("@components/screen/components/Credit/CreditAlert"),
        CreditDetails: () =>
            import("@components/screen/components/Credit/CreditDetails"),
        CreditDebt: () =>
            import("@components/screen/components/Credit/CreditDebt"),
        CreditPublicRecords: () =>
            import("@components/screen/components/Credit/CreditPublicRecords"),
        CreditAccounts: () =>
            import("@components/screen/components/Credit/CreditAccounts"),
    },
    props: {
        search: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: false,
            default: "screen",
        },
    },
    computed: {
        score() {
            return parseInt(
                this.$_.get(this.search, "hart.creditScore.score", 0)
            );
        },
        collection() {
            return this.$_.get(this.search, "hart.collection", {});
        },
        trade() {
            return this.$_.get(this.search, "hart.trade", {});
        },

        publicRecords() {
            return this.$_.get(this.search, "hart.public.details", []);
        },
        creditBalances() {
            return this.$_.get(this.search, "summary.creditBalances", {});
        },
        factors() {
            return this.$_.has(this.search, "hart.creditScore")
                ? Object.keys(this.search.hart.creditScore)
                    .filter((key) => key.search("factor") !== -1)
                    .map((key) => {
                        return this.search.hart.creditScore[key];
                    })
                : [];
        },
        alerts() {
            return this.$_.has(this.search, "hart.creditScore")
                ? Object.keys(this.search.hart.creditScore)
                    .filter((key) => key.toLowerCase().search("alert") !== -1)
                    .map((key) => {
                        return this.search.hart.creditScore[key];
                    })
                : [];
        },
        details() {
            return this.$_.get(this.search, "hart.subject.details", [])
                .length === 1
                ? Object.keys(this.search.hart.subject.details[0]).map(
                    (key) => {
                        return {
                            label: key,
                            text: this.search.hart.subject.details[0][key],
                        };
                    }
                )
                : [];
        },
    },
};
</script>

<style lang="scss" scoped></style>